// extracted by mini-css-extract-plugin
export default {"container":"qr_container__QOaJ3","layout":"qr_layout__py5YE","qrcode":"qr_qrcode__2jFeZ"};